import moment from "moment";
import { Box, Typography, List, ListItem } from "@mui/material";
import { _DATE_FORMAT } from "../../utils/constants";

export const ImportErrorDetails = ({ importError }) => {
  const errors = importError.errorDetails;

  return (
    <>
      <Box>
        <Typography level="h2">File name : {importError?.fileName}</Typography>
        <Typography level="h3">
          Imported at :
          {moment(importError?.importDate).format(_DATE_FORMAT["date_display"])}
        </Typography>
        <Typography level="h3">Site : {importError?.site?.name}</Typography>
      </Box>
      <List>
        {Object.keys(errors).map((lineNumber) => (
          <ListItem key={lineNumber}>
            {"Error line #" + lineNumber + " :"}
            <List>
              {errors[lineNumber].map((error, index) => (
                <ListItem key={index}>{error}</ListItem>
              ))}
            </List>
          </ListItem>
        ))}
      </List>
    </>
  );
};
